export const urls = {
    reviewsByRate: (id, rate) => `/api/users/${ id }/reviews/seller/rate/${ rate }`
};

export const initialState = {
    badReviews: {},
    goodReviews: {},
    excellentReviews: {},
    badReviewsMeta: {},
    goodReviewsMeta: {},
    excellentReviewsMeta: {},
    isFetching: false,
    isError: false
};

const getUrlWithoutParams = url => {
    return url.split('?')[0];
};

const transformRequestData = (state, action, rate) => {
    const url = getUrlWithoutParams(action.url);
    const reviews = state[`${ rate }Reviews`][url] || [];
    const data = { [url]: [...reviews, ...action.data.data] };
    const metadata = { [url]: action.data.metadata };

    return {
        badReviews: rate === 'bad' ? {
            ...state.badReviews,
            ...data
        } : {
            ...state.badReviews
        },
        badReviewsMeta: rate === 'bad' ? {
            ...state.badReviewsMeta,
            ...metadata
        } : {
            ...state.badReviewsMeta
        },
        goodReviews: rate === 'good' ? {
            ...state.goodReviews,
            ...data
        } : {
            ...state.goodReviews
        },
        goodReviewsMeta: rate === 'good' ? {
            ...state.goodReviewsMeta,
            ...metadata
        } : {
            ...state.goodReviewsMeta
        },
        excellentReviews: rate === 'excellent' ? {
            ...state.excellentReviews,
            ...data
        } : {
            ...state.excellentReviews
        },
        excellentReviewsMeta: rate === 'excellent' ? {
            ...state.excellentReviewsMeta,
            ...metadata
        } : {
            ...state.excellentReviewsMeta
        },
        isFetching: false,
        isError: false
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_REVIEWS_RATE_BAD':
        case 'REQUEST_REVIEWS_RATE_GOOD':
        case 'REQUEST_REVIEWS_RATE_EXCELLENT':
            return {
                badReviews: state.badReviews || {},
                goodReviews: state.goodReviews || {},
                excellentReviews: state.excellentReviews || {},
                badReviewsMeta: state.badReviewsMeta || {},
                goodReviewsMeta: state.goodReviewsMeta || {},
                excellentReviewsMeta: state.excellentReviewsMeta || {},
                isFetching: true,
                isError: false
            };
        case 'RECEIVE_REVIEWS_RATE_BAD':
            return transformRequestData(state, action, 'bad');
        case 'RECEIVE_REVIEWS_RATE_GOOD':
            return transformRequestData(state, action, 'good');
        case 'RECEIVE_REVIEWS_RATE_EXCELLENT':
            return transformRequestData(state, action, 'excellent');
        case 'ERROR_REVIEWS_RATE_BAD':
        case 'ERROR_REVIEWS_RATE_GOOD':
        case 'ERROR_REVIEWS_RATE_EXCELLENT':
            return {
                badReviews: state.badReviews || {},
                goodReviews: state.goodReviews || {},
                excellentReviews: state.excellentReviews || {},
                badReviewsMeta: state.badReviewsMeta || {},
                goodReviewsMeta: state.goodReviewsMeta || {},
                excellentReviewsMeta: state.excellentReviewsMeta || {},
                isFetching: false,
                isError: true
            };
        default:
            return state;
    }
};
